/* Oontly storefront behaviour: hero slider + sort redirect.
   Cart, links and pagination are native Liquid forms, so the page works without JS. */
(function () {
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-oo-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-oo-dot]'));
    var i = 0, paused = false;
    slides.forEach(function (s, k) { if (s.classList.contains('is-active')) i = k; });

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function step(d) { paused = true; show(i + d); }

    root.querySelectorAll('[data-oo-prev]').forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    root.querySelectorAll('[data-oo-next]').forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { paused = true; show(k); }); });

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 42) step(dx < 0 ? 1 : -1);
    }, { passive: true });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var every = parseInt(root.getAttribute('data-oo-interval'), 10) || 0;
    if (!reduce && every > 0) {
      setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, every);
    }
    show(i);
  }

  function initSort(root) {
    root.querySelectorAll('[data-oo-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-oo-hero]').forEach(initHero);
    document.querySelectorAll('[data-oo-collection]').forEach(initSort);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
